import React from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { getInsuranceProviderPlanDetailOptions } from '@generated';
import { PageSection } from '~/shared/section/PageSection';
import { FileText } from 'lucide-react';
import { BillingSettingsTab } from './tabs/BillingSettingsTab';
import { SubmissionSettingsTab } from './tabs/SubmissionSettingsTab';
import { CodesTab } from './tabs/CodesTab';
import { BillingRequirementsTab } from './tabs/BillingRequirementsTab';
import { ServiceRatesTab } from './tabs/ServiceRatesTab';
import { useRequiredParam } from '~/shared/routing/useRequiredParam';
import { QueryParamTabs } from '~/shared/components/tabs/QueryParamTabs';
import { Tabs } from '~/shared/components/tabs/Tabs';
import { PageLayout } from '~/shared/PageLayout';

const views = [
	{ label: 'Billing', value: 'billing' },
	{ label: 'Submission', value: 'submission' },
	{ label: 'Codes', value: 'codes' },
	{ label: 'Requirements', value: 'requirements' },
	{ label: 'Service Rates', value: 'rates' }
];

export function InsuranceProviderPlanDetail() {
	const planId = useRequiredParam('planId');
	const id = useRequiredParam('id');
	const navigate = useNavigate();
	const { data: plan } = useSuspenseQuery(getInsuranceProviderPlanDetailOptions(planId));

	return (
		<PageLayout pageHeader={{ title: 'Insurance Plan' }}>
			<PageSection title={plan.name} description={`Plan for ${plan.insuranceProviderName} - ${plan.billingModelLabel}}`} TitleIcon={FileText}>
				<QueryParamTabs defaultTab={views[0].value} className="gap-0">
					<Tabs.TabList aria-label="Plan Configuration">
						{views.map(view => (
							<Tabs.Tab id={view.value} key={view.value}>
								{view.label}
							</Tabs.Tab>
						))}
					</Tabs.TabList>
					<Tabs.TabPanel id="billing">
						<BillingSettingsTab plan={plan} />
					</Tabs.TabPanel>
					<Tabs.TabPanel id="submission">
						<SubmissionSettingsTab plan={plan} />
					</Tabs.TabPanel>
					<Tabs.TabPanel id="codes">
						<CodesTab plan={plan} />
					</Tabs.TabPanel>
					<Tabs.TabPanel id="requirements">
						<BillingRequirementsTab plan={plan} />
					</Tabs.TabPanel>
					<Tabs.TabPanel id="rates">
						<ServiceRatesTab plan={plan} />
					</Tabs.TabPanel>
				</QueryParamTabs>
			</PageSection>
		</PageLayout>
	);
}
